// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1wUj5","footer":"styles_footer__1xwq7"};